import Model from "./base/model";

class RouteTableOrder extends Model {
  resourceName() {
    return "route_table_order";
  }

  fields() {
    return {
      order_id: "",
      route_table_id: "",
      rates: "",
      weight_shipping_value: "",
      rates_value: "",
      total_value: "",
      alter: "",

      order: {jsonApi: "hasOne", type: "orders"},
      route_table: {jsonApi: "hasOne", type: "route_tables"},

    };
  }

}

export default new RouteTableOrder();
